import axios from 'axios'
import qs from 'qs'
import store from '@/store/index'
import {
	Message
} from 'element-ui'
import SERVER_CONFIG from '../../config/index'
// import md5 from 'js-md5'

// create an axios instance
console.log(SERVER_CONFIG)
const service = axios.create({
	baseURL: SERVER_CONFIG.SERVER // url = base url + request url

})

// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
service.defaults.headers.post['Content-Type'] = 'application/json'

// request interceptor
service.interceptors.request.use(
	(config) => {
		if (config.method.toLowerCase() === 'get') {
			if (config.url.toLowerCase().indexOf('common/download') != -1) {
				config.responseType = 'blob'
			}
			config.paramsSerializer = (params) => {
				return qs.stringify(params, {
					arrayFormat: 'repeat'
				})
			}
		}

		// if (
		//   config.method.toLowerCase() === 'post' &&
		//   config.headers['Content-Type'] === 'multipart/form-data'
		// ) {
		//   config.headers.jd_access_code_req = 'pc'
		// }
		// console.log(store)
		// const token = localStorage.getItem('token')
		const token = store.getters.token
		if (token) {
			config.headers.Authorization = token
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	(response) => {
		const res = response.data
		// 流跳出
		if (
			response.headers['content-type'] ===
			'application/vnd.ms-excel;charset=utf-8' ||
			res instanceof Blob
		) {
			return response
		}

		const code = ['0000']
		if (code.includes(res.code)) return res

		if (res.code !== '0000') {
			Message({
				message: res.msg || res.message,
				type: 'error',
				duration: 5 * 1000
			})
		}

		if (
			(res.code === '1200' || res.code === 401 || res.code === 403)) {
			store.dispatch('LOGOUT')
			window.location.reload()
		}

		return Promise.reject(res)
	},
	(error) => {
		Message({
			message: '系统维护中，请稍等再试',
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service
